/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';

/**
 * The FireDepartmentBase model module.
 * @module model/FireDepartmentBase
 * @version 1.1.0
 */
class FireDepartmentBase {
    /**
     * Constructs a new <code>FireDepartmentBase</code>.
     * Shared fire department fields with no required constraints.
     * @alias module:model/FireDepartmentBase
     */
    constructor() { 
        
        FireDepartmentBase.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>FireDepartmentBase</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FireDepartmentBase} obj Optional instance to populate.
     * @return {module:model/FireDepartmentBase} The populated <code>FireDepartmentBase</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FireDepartmentBase();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phoneNumber')) {
                obj['phoneNumber'] = ApiClient.convertToType(data['phoneNumber'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], Address);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FireDepartmentBase</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FireDepartmentBase</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['phoneNumber'] && !(typeof data['phoneNumber'] === 'string' || data['phoneNumber'] instanceof String)) {
            throw new Error("Expected the field `phoneNumber` to be a primitive type in the JSON string but got " + data['phoneNumber']);
        }
        // validate the optional field `address`
        if (data['address']) { // data not null
          Address.validateJSON(data['address']);
        }

        return true;
    }


}



/**
 * @member {String} name
 */
FireDepartmentBase.prototype['name'] = undefined;

/**
 * @member {String} email
 */
FireDepartmentBase.prototype['email'] = undefined;

/**
 * @member {String} phoneNumber
 */
FireDepartmentBase.prototype['phoneNumber'] = undefined;

/**
 * @member {module:model/Address} address
 */
FireDepartmentBase.prototype['address'] = undefined;






export default FireDepartmentBase;

